function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MglMap } from 'vue-mapbox';
import MapService from '@/services/mapService';
import { isInternetExplorer11 } from '@/utils/vuex';
import 'mapbox-gl/dist/mapbox-gl.css';
import get from 'lodash/get';
export default {
  name: 'CoreMapboxMglMap',
  components: {
    MglMap: MglMap
  },
  data: function data() {
    return {
      hideToRefresh: false
    };
  },
  computed: {
    mapAccessToken: function mapAccessToken() {
      return MapService.getAccessToken();
    },
    mapStyle: function mapStyle() {
      var light = 'mapbox://styles/mapbox/light-v9';
      var dark = 'mapbox://styles/mapbox/dark-v10';
      var dmStreets = 'mapbox://styles/digimondo/cjn4e7kzsjv8w2rlc0a574xu4';
      var satellite = 'mapbox://styles/mapbox/satellite-v9';
      var streets = 'mapbox://styles/mapbox/streets-v11';
      var queryMapStyle = parseInt(get(this.$route, 'query.mapstyle', 0), 10);
      var storeMapStyle = parseInt(get(this.$store.state.app, 'mapStyle', 0), 10);
      switch (queryMapStyle || storeMapStyle) {
        case 1:
          return !this.$store.state.app.UiTheme ? light : dark;
        case 2:
          return satellite;
        case 3:
          return streets;
        case 4:
          return dmStreets;
        default:
          return !this.$store.state.app.UiTheme ? light : dark;
      }
    },
    actualMapProps: function actualMapProps() {
      return _objectSpread({
        interactive: true,
        trackResize: true,
        accessToken: this.mapAccessToken,
        mapStyle: this.mapStyle
      }, this.$attrs);
    },
    isInteractive: function isInteractive() {
      return this.actualMapProps.interactive;
    }
  },
  watch: {
    'this.$store.state.app.mapStyle': {
      handler: function handler() {
        if (!this.$store.state.app.mapStyle) {
          this.$store.state.app.mapStyle = localStorage.getItem('mapStyle');
        }
      },
      immediate: true
    },
    isInteractive: function isInteractive() {
      this.rebuildMap();
    },
    '$store.state.app.map3DBuild': {
      handler: function handler() {
        this.toggleThreeDeeLayer();
      }
    }
  },
  created: function created() {
    // mapbox-gl-draw cannot be correctly transpiled for IE11 (actually, not at all, atm),
    // so since the map needs to work in that browser and the dependency cannot be selectively excluded,
    // instead include it dynamically on runtime here, if the browser is not IE11
    // (NOTE: "isNotIE11" will literally also be true for IE10, but in that browser nothing works anyway, so have at it.)
    if (!isInternetExplorer11() && !window.didLoadMaboxGlDrawLib) {
      var script = document.createElement('script');
      script.src = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.js';
      document.getElementsByTagName('head')[0].appendChild(script);
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.css';
      css.type = 'text/css';
      document.getElementsByTagName('head')[0].appendChild(css);
      window.didLoadMaboxGlDrawLib = true;
    }
  },
  methods: {
    rebuildMap: function rebuildMap() {
      var _this = this;
      this.hideToRefresh = true;
      this.$nextTick(function () {
        _this.hideToRefresh = false;
      });
    },
    onMapLoaded: function onMapLoaded(event) {
      var _this2 = this;
      if (this.map) {
        this.map.remove();
      }
      var map = event.map;
      this.map = map;
      var observer = new ResizeObserver(function () {
        try {
          event.map.resize();
          _this2.$emit('resize');
        } catch (e) {
          console.warn('Could not resize map (observer)', e);
        }
      });
      observer.observe(map.getContainer());
      this.toggleThreeDeeLayer();
      this.$emit('load', event);
    },
    toggleThreeDeeLayer: function toggleThreeDeeLayer() {
      if (this.$store.state.app.map3DBuild) {
        this.addThreeDeeLayer();
      } else {
        this.removeThreeDeeLayer();
      }
    },
    addThreeDeeLayer: function addThreeDeeLayer() {
      MapService.add3DBuildingLayer(this.map);
    },
    removeThreeDeeLayer: function removeThreeDeeLayer() {
      MapService.remove3DBuildingLayer(this.map);
    }
  }
};